import { connect } from 'react-redux'
import {
  selectAgentsForViewingCollisionByConversationId,
  selectAgentsForReplyingCollisionByConversationId,
  selectAgentsForNotingCollisionByConversationId,
  selectAgentsForTypingReplyCollisionByConversationId,
  selectAgentsForTypingNoteCollisionByConversationId,
} from 'ducks/collisions/selectors'
import AgentCollision from './view'

const select = () => {
  return (state, props) => {
    const { conversationId } = props

    return {
      viewingAgents: selectAgentsForViewingCollisionByConversationId(
        state,
        conversationId
      ),
      replyingAgents: selectAgentsForReplyingCollisionByConversationId(
        state,
        conversationId
      ),
      notingAgents: selectAgentsForNotingCollisionByConversationId(
        state,
        conversationId
      ),
      typingReplyAgents: selectAgentsForTypingReplyCollisionByConversationId(
        state,
        conversationId
      ),
      typingNoteAgents: selectAgentsForTypingNoteCollisionByConversationId(
        state,
        conversationId
      ),
    }
  }
}
export default connect(select, null)(AgentCollision)
